import React, { useEffect, useState } from "react";
import { apiUrl } from "../config/api";
import { adminAuthHeaders } from "../utils/authHeaders";

function UserList() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [toast, setToast] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedUserDetails, setSelectedUserDetails] = useState(null);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [detailsError, setDetailsError] = useState(null);
  const [activeTab, setActiveTab] = useState("balances");

  const showToast = (message, type = "success") => {
    setToast({ message, type });
    setTimeout(() => setToast(null), 3000);
  };

  const fetchUsers = async () => {
    try {
      const response = await fetch(apiUrl("/api/users"), {
        headers: adminAuthHeaders(),
      });
      const data = await response.json();

      if (response.ok) {
        setUsers(data.users || []);
      } else {
        setError(data.error || "خطا در دریافت اطلاعات");
      }
    } catch (err) {
      setError("خطا در اتصال به سرور");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const openUserDetails = async (userId) => {
    setDetailsLoading(true);
    setDetailsError(null);
    setSelectedUserDetails(null);
    setActiveTab("balances");

    try {
      const response = await fetch(apiUrl(`/api/users/${userId}/details`), {
        headers: adminAuthHeaders(),
      });
      const data = await response.json();

      if (response.ok && data.status === "success") {
        setSelectedUserDetails(data);
      } else {
        setDetailsError(data.error || "خطا در دریافت جزئیات کاربر");
      }
    } catch (err) {
      setDetailsError("خطا در اتصال به سرور");
    } finally {
      setDetailsLoading(false);
    }
  };

  const closeUserDetails = () => {
    setSelectedUserDetails(null);
    setDetailsError(null);
    setDetailsLoading(false);
    setActiveTab("balances");
  };

  const handleDelete = async (userId) => {
    if (!window.confirm("آیا از حذف این کاربر مطمئن هستید؟")) return;

    try {
      const response = await fetch(apiUrl(`/api/users/${userId}`), {
        method: "DELETE",
        headers: adminAuthHeaders(),
      });

      const data = await response.json();

      if (response.ok) {
        setUsers((prev) => prev.filter((user) => user.id !== userId));
        showToast("کاربر با موفقیت حذف شد", "success");
      } else {
        showToast(`خطا: ${data.error}`, "error");
      }
    } catch (err) {
      showToast("خطا در اتصال به سرور", "error");
    }
  };

  const filteredUsers = users.filter((user) => {
    const search = searchTerm.toLowerCase();
    return (
      user.identifier?.toLowerCase().includes(search) ||
      user.firstName?.toLowerCase().includes(search) ||
      user.lastName?.toLowerCase().includes(search) ||
      user.phone?.includes(search)
    );
  });

  const formatNumber = (num) => {
    const persianDigits = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
    return num.toString().replace(/\d/g, (d) => persianDigits[d]);
  };

  const formatAmount = (num) => {
    if (num === null || num === undefined || num === "") return "-";
    return Number(num).toLocaleString("fa-IR", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  };

  const formatDate = (value) => {
    if (!value) return "-";
    return new Date(value).toLocaleString("fa-IR");
  };

  const detailsUser = selectedUserDetails?.user;
  const detailsTransactions = selectedUserDetails?.transactions || [];
  const detailsStatement = selectedUserDetails?.statement || [];

  return (
    <div>
      {toast && (
        <div
          style={{
            position: "fixed",
            top: "20px",
            right: "20px",
            padding: "15px 25px",
            borderRadius: "8px",
            backgroundColor: toast.type === "success" ? "#4CAF50" : "#f44336",
            color: "white",
            fontSize: "16px",
            zIndex: 9999,
            boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
            direction: "rtl",
          }}
        >
          {toast.message}
        </div>
      )}

      <div className="SelectedHeader">
        در این قسمت شما لیست کاربران و کاربران آنلاین خود را می بینید. همچنین
        می توانید با کلیک بر روی هر کاربر، تمام جزئیات او را به صورت تب به تب
        مشاهده کنید.
      </div>

      <div>
        <input
          className="SearchBox mt-3"
          placeholder="جستوجو کاربران"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div className="UsersNav mt-3">
        <p>شناسه کاربر</p>
        <p>آنلاین</p>
        <p>نام کاربر</p>
        <p>نام خانوادگی</p>
        <p>شماره تماس</p>
        <p>رمز عبور</p>
        <p>مانده پول</p>
        <p>مانده طلا</p>
        <p>حذف</p>
      </div>

      {loading ? (
        <p style={{ textAlign: "center", marginTop: "20px" }}>در حال بارگذاری...</p>
      ) : error ? (
        <p style={{ textAlign: "center", marginTop: "20px", color: "red" }}>{error}</p>
      ) : filteredUsers.length === 0 ? (
        <p style={{ textAlign: "center", marginTop: "20px" }}>کاربری یافت نشد.</p>
      ) : (
        filteredUsers.map((user) => (
          <div
            key={user.id}
            className="UsersRow mt-2"
            onClick={() => openUserDetails(user.id)}
          >
            <p>{user.identifier}</p>
            <p>
              <span className={user.isOnline ? "Online" : "Offline"}></span>
            </p>
            <p>{user.firstName}</p>
            <p>{user.lastName}</p>
            <p>{user.phone}</p>
            <p>{user.password}</p>
            <p className="ColorGold">{formatNumber(user.moneyBalance)} ریال</p>
            <p className="ColorGold">{formatNumber(user.goldBalance)} گرم</p>
            <p>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleDelete(user.id);
                }}
                style={{
                  backgroundColor: "#f44336",
                  color: "white",
                  border: "none",
                  padding: "5px 10px",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                حذف
              </button>
            </p>
          </div>
        ))
      )}

      {(detailsLoading || detailsError || selectedUserDetails) && (
        <div className="modal-overlay" onClick={closeUserDetails}>
          <div
            className="modal-content user-details-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="trade-modal-header">
              <div className="trade-modal-title">
                <span>جزئیات کاربر</span>
                {detailsUser && (
                  <span className="user-details-name">
                    {detailsUser.firstName} {detailsUser.lastName}
                  </span>
                )}
              </div>
              <button className="modal-close-btn" onClick={closeUserDetails}>
                ×
              </button>
            </div>

            <div className="user-details-body">
              {detailsLoading ? (
                <p className="user-details-empty">در حال دریافت جزئیات...</p>
              ) : detailsError ? (
                <p className="user-details-empty user-details-error">{detailsError}</p>
              ) : (
                <>
                  <div className="user-details-tabs">
                    <button
                      className={activeTab === "balances" ? "active" : ""}
                      onClick={() => setActiveTab("balances")}
                    >
                      موجودی طلا و پولی
                    </button>
                    <button
                      className={activeTab === "transactions" ? "active" : ""}
                      onClick={() => setActiveTab("transactions")}
                    >
                      جزئیات تراکنش
                    </button>
                    <button
                      className={activeTab === "statement" ? "active" : ""}
                      onClick={() => setActiveTab("statement")}
                    >
                      جزئیات گردش حساب
                    </button>
                  </div>

                  {activeTab === "balances" && detailsUser && (
                    <div className="user-details-panel">
                      <div className="user-summary-grid">
                        <div className="user-summary-card">
                          <span>مانده پول</span>
                          <strong>{formatAmount(detailsUser.moneyBalance)} ریال</strong>
                        </div>
                        <div className="user-summary-card">
                          <span>مانده طلا</span>
                          <strong>{formatAmount(detailsUser.goldBalance)} گرم</strong>
                        </div>
                        <div className="user-summary-card">
                          <span>نام و نام خانوادگی</span>
                          <strong>
                            {detailsUser.firstName} {detailsUser.lastName}
                          </strong>
                        </div>
                        <div className="user-summary-card">
                          <span>شماره تماس</span>
                          <strong>{detailsUser.phone || "-"}</strong>
                        </div>
                        <div className="user-summary-card">
                          <span>کد ملی</span>
                          <strong>{detailsUser.nationalCode || "-"}</strong>
                        </div>
                        <div className="user-summary-card">
                          <span>نام طلافروشی</span>
                          <strong>{detailsUser.goldsmithName || "-"}</strong>
                        </div>
                        <div className="user-summary-card">
                          <span>تاریخ تایید</span>
                          <strong>{formatDate(detailsUser.approvedAt)}</strong>
                        </div>
                        <div className="user-summary-card">
                          <span>وضعیت اتصال</span>
                          <strong>{detailsUser.isOnline ? "آنلاین" : "آفلاین"}</strong>
                        </div>
                        <div className="user-summary-card full">
                          <span>آدرس</span>
                          <strong>{detailsUser.shopAddress || "-"}</strong>
                        </div>
                      </div>
                    </div>
                  )}

                  {activeTab === "transactions" && (
                    <div className="user-details-panel">
                      {detailsTransactions.length === 0 ? (
                        <p className="user-details-empty">
                          تراکنشی برای این کاربر ثبت نشده است.
                        </p>
                      ) : (
                        <div className="user-details-table-wrap">
                          <table className="user-details-table">
                            <thead>
                              <tr>
                                <th>موضوع</th>
                                <th>نوع</th>
                                <th>مقدار</th>
                                <th>شرح</th>
                                <th>تاریخ</th>
                              </tr>
                            </thead>
                            <tbody>
                              {detailsTransactions.map((item) => (
                                <tr key={item.id}>
                                  <td>{item.title || "-"}</td>
                                  <td>{item.type === "money" ? "پولی" : "طلا"}</td>
                                  <td
                                    className={
                                      Number(item.amount) >= 0
                                        ? "transaction-plus"
                                        : "transaction-minus"
                                    }
                                  >
                                    {formatAmount(item.amount)}{" "}
                                    {item.type === "money" ? "ریال" : "گرم"}
                                  </td>
                                  <td>{item.description || "-"}</td>
                                  <td>{formatDate(item.createdAt)}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  )}

                  {activeTab === "statement" && (
                    <div className="user-details-panel">
                      {detailsStatement.length === 0 ? (
                        <p className="user-details-empty">
                          گردش حسابی برای این کاربر ثبت نشده است.
                        </p>
                      ) : (
                        <div className="user-details-table-wrap">
                          <table className="user-details-table">
                            <thead>
                              <tr>
                                <th>تاریخ</th>
                                <th>موضوع</th>
                                <th>نوع</th>
                                <th>مقدار</th>
                                <th>مانده قبل</th>
                                <th>مانده بعد</th>
                              </tr>
                            </thead>
                            <tbody>
                              {detailsStatement.map((item) => (
                                <tr key={item.id}>
                                  <td>{formatDate(item.createdAt)}</td>
                                  <td>{item.title || "-"}</td>
                                  <td>{item.type === "money" ? "پولی" : "طلا"}</td>
                                  <td
                                    className={
                                      Number(item.amount) >= 0
                                        ? "transaction-plus"
                                        : "transaction-minus"
                                    }
                                  >
                                    {formatAmount(item.amount)}{" "}
                                    {item.type === "money" ? "ریال" : "گرم"}
                                  </td>
                                  <td>
                                    {formatAmount(item.balanceBefore)}{" "}
                                    {item.type === "money" ? "ریال" : "گرم"}
                                  </td>
                                  <td>
                                    {formatAmount(item.balanceAfter)}{" "}
                                    {item.type === "money" ? "ریال" : "گرم"}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default UserList;
